import React from 'react';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';

const MobileSendModal = ({ open, closeModal, details }) => (
  <Modal open={open}>
    <div className="verify__send-mobile--container">
      <div className="verify__send-mobile--text"> A new verification code has been sent to your phone.</div>
      <div className="verify__send-mobile--button">
        <Button fullWidth label="Okay" onClick={() => closeModal()} />
      </div>
    </div>
  </Modal>
);

export default MobileSendModal;



// WEBPACK FOOTER //
// ./src/components/User/MobileSendModal.js